module.exports = __webpack_public_path__ + "img/img14.9b6277f7.svg";